import React from "react";

import { useTranslation } from "@refinedev/core";

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";

interface ConfirmEmailChangeDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const ConfirmEmailChangeDialog: React.FC<ConfirmEmailChangeDialogProps> = ({ open, onCancel, onConfirm }) => {
  const { translate } = useTranslation();

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth aria-labelledby="confirm-email-change-dialog-title">
      <DialogTitle id="confirm-email-change-dialog-title">
        <Stack alignItems="center">
          <Typography variant="h3">{translate("pages.patientInfoCard.emailChange.title")}</Typography>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" color="text.primary">
          {translate("pages.patientInfoCard.emailChange.message")}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="dialog" color="inherit" onClick={onCancel}>
          {translate("buttons.cancel")}
        </Button>
        <Button variant="dialog" color="success" onClick={onConfirm}>
          {translate("buttons.continue")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
